import '../graph.scss';
import AddAnnotation from './addAnnotation';
import ViewAnnotation from './viewAnnotation';

type AnnotationType = 'target' | 'behavior';

interface AnnotationsProperties {
	clientId: string;
	id: string;
	name: string;
	type: AnnotationType;
}

const Annotations = ({ clientId, id, name, type }: AnnotationsProperties) => (
	<div className="graphAnnotationsContainer">
		<AddAnnotation id={id} type={type} clientId={clientId} />
		<ViewAnnotation id={id} name={name} type={type} />
	</div>
);

export default Annotations;
